import globals from "@homer.core/globals";
import isClass from "@homer.utility/validator.isclass";
import isFunction from "@homer.utility/validator.isfunction";

class Factory {
    preload(name, importance = null) {
        const state = new Set([
            ...(globals?.demand?.list || []),
            ...[...document.querySelectorAll('meta[itemprop="preload"]')].reduce((accumulator, node) => {
                accumulator.push(...(node.getAttribute("content") || "").split(","));

                return accumulator;
            }, []),
        ]);

        name.split(",").forEach((name) => {
            if (!state.has(name)) {
                const meta = document.createElement("meta");

                meta.setAttribute("itemprop", "preload");
                meta.setAttribute("content", name);

                if (importance === "critical" || importance === "high") {
                    meta.setAttribute("importance", importance);
                }

                document.body.appendChild(meta);
            }
        });
    }

    get(name, ...parameter) {
        const request = globals.demand.request(name);

        return Object.defineProperties(
            request.then(([module]) => {
                return isClass(module)
                    ? isFunction(module.obtain)
                        ? module.obtain(...parameter)
                        : new module(...parameter)
                    : module;
            }),
            {
                abort: {
                    value: request.abort.bind(request),
                    enumerable: true,
                },
            },
        );
    }
}

export default new Factory();
